import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';
import { formatInTimeZone } from 'date-fns-tz';
import IE_Logo from '../assets/IE_Logo.png'; // Path from src/components/ to src/assets/
import TPC_Logo from '../assets/TPC_Logo.png'; // Path from src/components/ to src/assets/

const Header = ({ timezone = 'UTC', siteName = '' }) => {
  const [utcClock, setUtcClock] = useState('');
  const headerTitle = siteName ? `${siteName} - Field Safety Dashboard` : 'Field Safety Dashboard';

  useEffect(() => {
    const update = () => {
      try {
        setUtcClock(formatInTimeZone(new Date(), timezone, 'yyyy-MM-dd HH:mm zzz'));
      } catch (error) {
        console.error('Header clock timezone formatting failed:', error);
        setUtcClock(formatInTimeZone(new Date(), 'UTC', 'yyyy-MM-dd HH:mm zzz'));
      }
    };
    update();
    const timer = setInterval(update, 1000);
    return () => clearInterval(timer);
  }, [timezone]);

  return (
    <AppBar
      position="sticky"
      sx={{
        background:
          'linear-gradient(100deg, rgba(9, 54, 51, 0.98) 0%, rgba(15, 118, 110, 0.96) 46%, rgba(39, 106, 98, 0.96) 100%)',
        zIndex: 1300,
        borderBottom: '1px solid rgba(255, 255, 255, 0.18)',
        boxShadow: '0 14px 30px rgba(11, 40, 35, 0.24)',
      }}
    >
      <Toolbar
        sx={{
          minHeight: { xs: 82, md: 92 },
          px: { xs: 1.25, md: 2.25 },
          display: 'grid',
          gridTemplateColumns: 'auto minmax(0, 1fr) auto',
          alignItems: 'center',
          columnGap: 1.5,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            pointerEvents: 'none',
            opacity: 0.35,
            background:
              'repeating-linear-gradient(120deg, rgba(255, 255, 255, 0.18) 0px, rgba(255, 255, 255, 0.18) 1px, transparent 1px, transparent 22px)',
          }}
        />
        {/* Left Side: IE Logo with Link */}
        <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0, position: 'relative' }}>
          <a href="https://ivanhoeelectric.com/" target="_blank" rel="noopener noreferrer">
            <img
              src={IE_Logo}
              alt="IE Logo"
              style={{ height: '44px', width: 'auto' }}
            />
          </a>
        </Box>

        {/* Center: Title */}
        <Box sx={{ textAlign: 'center', px: 1, minWidth: 0, position: 'relative' }}>
          <Typography
            variant="h4"
            sx={{
              color: '#ffffff',
              fontSize: { xs: '1.15rem', md: '1.6rem' },
              letterSpacing: 0.4,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              lineHeight: 1.1,
            }}
          >
            {headerTitle}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: 'rgba(237, 250, 247, 0.82)',
              letterSpacing: 0.8,
              fontWeight: 600,
              fontFamily: '"Space Grotesk", "Manrope", sans-serif',
              fontSize: '0.73rem',
            }}
          >
            {utcClock}
          </Typography>
        </Box>

        {/* Right Side: TPC Logo with Link */}
        <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0, position: 'relative' }}>
          <a href="https://www.tipple.consulting/" target="_blank" rel="noopener noreferrer">
            <img
              src={TPC_Logo}
              alt="TPC Logo"
              style={{ height: '44px', width: 'auto' }}
            />
          </a>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
